import { Select, MenuItem, FormControl, InputLabel, Checkbox, OutlinedInput, ListItemText } from '@mui/material'
import { head } from 'lodash'

const SelectFieldCheckbox = ({ label, onChange, value, options, id, optionName, disabled }) => {
  return (
    <div style={{ display: 'flex', flexGrow: 1 }}>
      <FormControl fullWidth size="small">
        <InputLabel id={`${id}-checkbox-label}`}>{label}</InputLabel>
        <Select
        multiple
          style={
            disabled
              ? { display: 'flex', flexGrow: 1, color: '#f00', backgroundColor: 'hsl(0, 0%, 95%)' }
              : { display: 'flex', flexGrow: 1 }
          }
          labelId={`${id}-label}`}
          id={id}
          value={value}
          onChange={(event) => {
            let duplicateRemoved = []
            event.target.value.forEach((item) => {
              if (
                duplicateRemoved.findIndex((o) => {
                  return o[id] === item[id]
                }) >= 0
              ) {
                duplicateRemoved = duplicateRemoved.filter((x) => x[id] === item[id])
              } else {
                duplicateRemoved.push(item)
              }
            })
            const result = duplicateRemoved.map((item) => parseInt(item[id]))
            onChange(result)
          }}
          input={<OutlinedInput label={label} />}
          renderValue={(selected) => {
            if (head(value) === -1) {
              return 'All'
            }

            return selected.map((x) => x?.[optionName]).join(', ')
          }}
          disabled={disabled}
        >
          {options.map((option) => (
            <MenuItem key={option[id]} value={option}>
              <Checkbox checked={value?.findIndex((item) => item?.[id] === option?.[id]) >= 0} size="small" />
              <ListItemText primary={option?.[optionName]} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  )
}

export default SelectFieldCheckbox
